module.exports = __webpack_public_path__ + "fanny allongée.png?1e250f7a6e5edc66b09d23fd5eea73ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fanny allongée.png
// module id = 41
// module chunks = 0